import {OverlayToaster, Toaster} from "@blueprintjs/core";

const toasterPromise = OverlayToaster.create({position: "top-right"});

export const toaster: Pick<Toaster, 'show'> = {
  show: async (props) => {
    const t = await toasterPromise;
    t.show(props);
  },
};
